import React from 'react';
import { ANALYTICS_ACTION_CLICK } from '../../AnalyticsProvider';
import './article.scss';

const Article = ({
  title,
  image = null,
  link,
  logo,
  recordAnalytics,
}: {
  title: string;
  image?: string | null;
  link: string;
  logo: string;
  recordAnalytics: (analyticsEvent: string, analyticsLabel: string) => void;
}) => (
  <a
    href={link}
    className="starter-guide-article"
    target="_blank"
    rel="noreferrer"
    data-testid="starter-guide-article"
    onClick={() => {
      recordAnalytics(ANALYTICS_ACTION_CLICK, title);
    }}
  >
    <div className="starter-guide-article__main">
      <small>{logo}</small>
      <p
        className="starter-guide-article__title"
        dangerouslySetInnerHTML={{ __html: title }} // eslint-disable-line react/no-danger
      />
    </div>
    <div>{image ? <img src={image} className="starter-guide-article__image" alt="" /> : null}</div>
  </a>
);

export default Article;
